<template>
  <div>
    <v-client-table
      class="fixed_header" ref="tableListe"
      :data="reseaux"
      :columns="columns"
      :options="options"
      @filter="tableIsFilter">
      <div slot="selected" slot-scope="props" style="text-align:center">
        <input type="checkbox" id="checkbox" :value="props.row" v-model="props.row.selected"
               @click="ajoutPanier(props.row)">
      </div>
      <div slot="dispoClass" slot-scope="props"
           class="image is-28x65 button noHandCursor centrer_disponibilite"
           v-bind:class="props.row.dispoClass">
        <div class="contNbrFaces">
          <div class="container is-size-6">
            {{props.row.nbrFacesRestantes}}/{{props.row.nbrFacesTotal}}
          </div>
        </div>
      </div>
      <div slot="nbFaces" slot-scope="props">
        <div class="is-pulled-right">{{props.row.nbFaces}}</div>
      </div>
      <div slot="tarifBrut" slot-scope="props">
        <div class="is-pulled-right">{{props.row.tarifBrutString}}</div>
      </div>
      <div slot="dureeConservation" slot-scope="props">
        <div class="is-pulled-right">{{props.row.dureeConservation}}</div>
      </div>
      <div slot="depCode" slot-scope="props">
        <div class="is-pulled-right">{{props.row.depCode}}</div>
      </div>
      <div slot="colorPicker" slot-scope="props" style="text-align:center">
        <color-marker
          v-model="props.row.couleur"
          @input="colorsPickerChange(props.row)"/>
      </div>
      <div slot="addPanier" slot-scope="props" style="text-align:center">
        <button class="button is-primary is-small" :class="props.row.selected ?
          'is-success' : 'is-primary'" @click="ajouterAuPanier(props.row)">
          <b-icon
            icon="cart"
            size="12"
            style="cursor:pointer;">
          </b-icon>
        </button>
      </div>
      <div slot="selected" slot-scope="props">
        <input class="checkbox-disabled" type="checkbox" disabled :checked="props.row.selected">
      </div>
      <div slot="zoom" slot-scope="props" style="text-align:center">
        <b-button
          class="has-background-transparent no_border pa-0"
          @click="zoomReseau(props.row)"
          :disabled="!isValidLatLng(props.row.latitude, props.row.longitude)">
          <b-icon icon="google-maps" type="is-primary"/>
        </b-button>
      </div>
      <div slot="fichepdf" slot-scope="props" style="text-align:center">
        <a @click="exporterFicheProduit(props.row)">
          <b-icon icon="file-pdf" type="is-danger"></b-icon>
        </a>
      </div>
      <div slot="diaporama" slot-scope="props" style="text-align:center">
        <a @click="ouvrirDiaporama(props.row)">
          <b-icon icon="image-multiple" type="is-primary"></b-icon>
        </a>
      </div>
    </v-client-table>
    <b-modal
      v-model="isComponentOuvrirListeFaces"
      has-modal-card
      class="modal modal-liste-faces"
      width="80vw">
      <Consultation
        :reseau="reseau"
        :disabled="disabled"
        :no-update="true"
        :index-tabs="1"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment/moment';
import gestionErreur from '@/services/general/gestionErreur';
import colorMarker from '@/components/general/colorMarker';
import { TEXTS, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import * as types from '@/store/creationOpportunite/venteReseauxTempo-mutation-type';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import exporterFicheProduit from '@/services/reseauxTempo/exporterFicheProduit';
import getReseauAvecFaces from '@/services/reseauxTempo/getReseauAvecFaces';

import Consultation from '@/components/creationOpportunite/panier/composantsProduits/venteReseauxTempo/consultation';

const VenteReseauxTempo = createNamespacedHelpers('venteReseauxTempo');
const Modal = createNamespacedHelpers('modal');
const Panier = createNamespacedHelpers('panier');

export default {
  name: 'liste',
  components: {
    colorMarker,
    Consultation,
  },
  data() {
    return {
      refDropDown: 'refDropDown',
      trad: {
        dispoClass: 'Dispo',
        libelle: '↑↓ Libelle',
        depCode: '↑↓ Dept.',
        ville: '↑↓ Ville',
        nbFaces: '↑↓ Nb Faces prévues ',
        confrere: '↑↓ Confrère',
        format: '↑↓ Format',
        tarif: '↑↓ Tarif brut',
        tempsConservation: '↑↓ Durée (semaine)',
        selected: '',
        jourDepartLibelle: '↑↓ Départ',
        colorPicker: 'Couleur',
        addPanier: '',
        zoom: 'Carto',
        code: '↑↓ Code',
        type: '↑↓ Type',
        fichepdf: 'PDF',
        diaporama: 'Diapo',
        isComponentOuvrirListeFaces: false,
      },
      checked: [],
      dataProposition: {},
      reseau: null,
      isComponentOuvrirListeFaces: false,
      disabled: true,
      isFiltred: false,
      continue: false,
    };
  },
  watch: {
    reseaux(val) {
      this.actionsUpdateMarkerReseauFilter(val);
    },
  },
  computed: {
    ...VenteReseauxTempo.mapGetters({
      showReseaux: 'showReseaux',
      reseauxWithFilter: 'reseauxWithFilter',
      markersReseaux: 'markersReseaux',
      dateDeVisualisation: 'dateDeVisualisation',
      dataPropositions: 'dataPropositions',
      getActiveTabReseau: 'activeTabReseau',
      getZoomMarker: 'zoomMarker',
      getFiltreDispoReseau: 'filtreDispoReseau',
    }),
    ...Panier.mapGetters({
      reseauxTempoPanier: 'reseauxTempoPanier',
    }),
    ...Modal.mapGetters({
      getIsComponentDiaporama: 'isComponentDiaporama',
      getFacesReseauSelect: 'facesSelectDiapo',
    }),
    reseaux() {
      if (this.getFiltreDispoReseau.includes('is-success')
          && this.getFiltreDispoReseau.includes('is-warning')
          && this.getFiltreDispoReseau.includes('is-danger')) {
        return this.reseauxWithFilter.filter(el => el.dispoClass === 'is-success'
          || el.dispoClass === 'is-warning'
          || el.dispoClass === 'is-danger');
      }
      if (this.getFiltreDispoReseau.includes('is-success')
          && this.getFiltreDispoReseau.includes('is-warning')) {
        return this.reseauxWithFilter.filter(el => el.dispoClass === 'is-success'
          || el.dispoClass === 'is-warning');
      }
      if (this.getFiltreDispoReseau.includes('is-success')
          && this.getFiltreDispoReseau.includes('is-danger')) {
        return this.reseauxWithFilter.filter(el => el.dispoClass === 'is-success'
          || el.dispoClass === 'is-danger');
      }
      if (this.getFiltreDispoReseau.includes('is-warning')
          && this.getFiltreDispoReseau.includes('is-danger')) {
        return this.reseauxWithFilter.filter(el => el.dispoClass === 'is-warning'
          || el.dispoClass === 'is-danger');
      }
      if (this.getFiltreDispoReseau.includes('is-success')) {
        return this.reseauxWithFilter.filter(el => el.dispoClass === 'is-success');
      }
      if (this.getFiltreDispoReseau.includes('is-warning')) {
        return this.reseauxWithFilter.filter(el => el.dispoClass === 'is-warning');
      }
      if (this.getFiltreDispoReseau.includes('is-danger')) {
        return this.reseauxWithFilter.filter(el => el.dispoClass === 'is-danger');
      }
      return this.reseauxWithFilter;
    },
    activeTab: {
      get() {
        return this.getActiveTabReseau;
      },
      set(value) {
        this.setActiveTabReseau(value);
      },
    },
    facesReseauSelectDiapo: {
      get() {
        return this.getFacesReseauSelect;
      },
      set(value) {
        this.setFacesReseauSelect(value);
      },
    },
    isComponentDiaporama: {
      get() {
        return this.getIsComponentDiaporama;
      },
      set(value) {
        this.setIsComponentDiaporama(value);
      },
    },
    zoomMarker: {
      get() {
        return this.getZoomMarker;
      },
      set(value) {
        this.setZoomMarker(value);
      },
    },
    columns() {
      return ['addPanier', 'dispoClass', 'code', 'libelle', 'depCode', 'ville', 'nbFaces', 'type', 'confrere', 'format', 'tarifBrut', 'dureeConservation', 'jourDepartLibelle', 'zoom', 'fichepdf', 'diaporama', 'colorPicker'];
    },
    options() {
      return {
        headings: {
          selected: this.trad.selected,
          dispoClass: this.trad.dispoClass,
          libelle: this.trad.libelle,
          depCode: this.trad.depCode,
          ville: this.trad.ville,
          nbFaces: this.trad.nbFaces,
          confrere: this.trad.confrere,
          format: this.trad.format,
          tarifBrut: this.trad.tarif,
          dureeConservation: this.trad.tempsConservation,
          jourDepartLibelle: this.trad.jourDepartLibelle,
          colorPicker: this.trad.colorPicker,
          addPanier: this.trad.addPanier,
          zoom: this.trad.zoom,
          code: this.trad.code,
          type: this.trad.type,
          fichepdf: this.trad.fichepdf,
          diaporama: this.trad.diaporama,
        },
        filterByColumn: true,
        filterable: ['code', 'libelle', 'depCode', 'ville', 'type', 'confrere'],
        perPageValues: PER_PAGE_VALUE,
        perPage: 99999,
        texts: TEXTS,
        columnsClasses: {
          format: 'colonneBoutonFaceLcListe100px ellipsis has-text-centered',
          libelle: 'ellipsis ventesReseauxListeTailleColonneLibelle',
          dispoClass: 'colonneBoutonReseauTempoListe has-text-centered',
          ville: 'ellipsis ventesReseauxListeTailleColonneVille',
          confrere: 'ellipsis ventesReseauxListeTailleColonneConfrere',
          type: 'ellipsis ventesReseauxListeTailleColonneType',
          jourDepartLibelle: 'colonneBoutonFaceLcListe100px ellipsis has-text-centered',
          selected: 'colonneBoutonFaceLcListe has-text-centered',
          code: 'colonneBoutonFaceLcListe100px',
          depCode: 'colonneBoutonFaceLcListe100px has-text-centered',
          nbFaces: 'colonneBoutonFaceLcListe100px ellipsis has-text-centered',
          fichepdf: 'colonneBoutonFaceLcListe ellipsis has-text-centered',
          diaporama: 'colonneBoutonFaceLcListe has-text-centered',
          colorPicker: 'colonneBoutonFaceLcListe has-text-centered',
          addPanier: 'colonneBoutonFaceLcListe45px has-text-centered',
          zoom: 'colonneBoutonFaceLcListe has-text-centered',
        },
        customSorting: {
          jourDepartLibelle(ascending) {
            return (a, b) => {
              if (ascending) {
                return a.jourDepart >= b.jourDepart ? 1 : -1;
              }
              return a.jourDepart <= b.jourDepart ? 1 : -1;
            };
          },
        },
      };
    },
  },
  methods: {
    ...VenteReseauxTempo.mapMutations({
      setReseauxSelected: types.SET_RESEAUX_SELECTED,
      setReseauxWithFilter: types.SET_RESEAUX_WITH_FILTER,
      setActiveTabReseau: types.SET_ACTIVE_TAB_RESEAU,
      setZoomMarker: types.SET_ZOOM_MARKER,
    }),
    ...VenteReseauxTempo.mapActions({
      actionUpdateMarkerReseaux: 'updateMarkerReseau',
      actionsEnvoyerCouleurReseau: 'envoyerCouleurReseau',
      actionsGestionPanier: 'gestionPanier',
      actionsUpdateMarkerReseauFilter: 'updateMarkerReseauFilter',
    }),
    ...Modal.mapMutations({
      setIsComponentDiaporama: typesModal.SET_IS_COMPONENT_DIAPORAMA,
      setFacesReseauSelect: typesModal.SET_FACES_SELECT_DIAPO,
    }),
    async colorsPickerChange(reseau) {
      const index = this.reseaux.findIndex(el => el.num === reseau.num);
      this.reseaux[index].couleur = reseau.couleur;
      this.setReseauxWithFilter(this.reseaux);
      await this.actionsEnvoyerCouleurReseau({ reseau: reseau, couleur: reseau.couleur });
    },
    ajouterAuPanier(reseau) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.ajouterAuPanierAsync(reseau).then(() => {
        loadingComponent.close();
      }).catch((e) => {
        gestionErreur(`Erreur de l'ajout au panier du reseau tempo n°${reseau.num}`, e);
        loadingComponent.close();
        throw (e);
      });
    },
    async ajouterAuPanierAsync(reseau) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      const semaine = moment(this.dateDeVisualisation).isoWeek();
      const annee = moment(this.dateDeVisualisation).isoWeekYear();
      await this.actionsGestionPanier({
        resNum: reseau.num,
        semaine: semaine,
        annee: annee,
        dataPropositions: reseau.dataProposition,
      });

      const reseauPanier = this.reseauxTempoPanier.find((el) => {
        return el.num === reseau.num;
      });
      this.setReseauxSelected({
        data: reseau.num,
        value: reseauPanier !== undefined && reseauPanier !== null,
      });
      loadingComponent.close();
    },
    async zoomReseau(reseau) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        this.reseau = await getReseauAvecFaces(reseau, this.dateDeVisualisation);
        this.isComponentOuvrirListeFaces = true;
      } catch (e) {
        gestionErreur(`Erreur lors de la récupération des faces du réseau tempo n°${reseau.num}`, e);
      } finally {
        loadingComponent.close();
      }
    },
    ouvrirDiaporama(reseau) {
      reseau.listeFaces.forEach((el) => {
        el.libelleReseau = reseau.libelle;
      });
      this.facesReseauSelectDiapo = reseau.listeFaces;
      this.isComponentDiaporama = true;
    },
    async exporterFicheProduit(data) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        await exporterFicheProduit(data);
        loadingComponent.close();
      } catch (e) {
        gestionErreur(`Erreur lors de la generation du PDF du réseau id: ${data.num}`, e);
        loadingComponent.close();
      }
    },
    tableIsFilter() {
      this.$emit('liste', {
        data: this.$refs.tableListe.filteredData,
        type: 'reseauxTempo',
      });
    },
  },
  mounted() {
    this.tableIsFilter();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxTempo/recherche/liste.vue